/*
 * Minimum bestelbedrag (wholesale).
 *
 * Leest de data-attributen van snippets/cart-minimum-order.liquid en schakelt de
 * afrekenknoppen (#checkout op de cart-pagina, #CartDrawer-Checkout in de drawer)
 * uit zolang het winkelwagentotaal onder het minimum ligt. De melding zelf wordt
 * server-side gerenderd; dit script houdt enkel de knopstatus in sync wanneer de
 * cart via AJAX wordt bijgewerkt (en de knop zelf niet opnieuw gerenderd wordt).
 */
(function () {
  if (window.__cartMinimumOrderInit) return;
  window.__cartMinimumOrderInit = true;

  var CHECKOUT_BUTTONS = '#checkout, #CartDrawer-Checkout';

  function isBelowMinimum() {
    var boxes = document.querySelectorAll('[data-cart-minimum]');
    var below = false;
    boxes.forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min-cents') || '0', 10);
      var total = parseInt(box.getAttribute('data-cart-cents') || '0', 10);
      if (min > 0 && total > 0 && total < min) below = true;
    });
    return below;
  }

  function evaluate() {
    var below = isBelowMinimum();
    document.querySelectorAll(CHECKOUT_BUTTONS).forEach(function (btn) {
      if (below) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-min-blocked', 'true');
      } else if (btn.getAttribute('data-min-blocked')) {
        // Alleen onze eigen blokkade opheffen, niet de lege-winkelwagen-blokkade.
        btn.removeAttribute('data-min-blocked');
        if (!btn.closest('.is-empty')) btn.removeAttribute('disabled');
      }
    });
    // Express checkout-knoppen (Shop Pay, PayPal, ...) verbergen onder het minimum,
    // anders omzeilen ze de afrekenknop.
    document.querySelectorAll('[data-min-express-buttons]').forEach(function (box) {
      box.style.display = below ? 'none' : '';
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      evaluate();
    });
  }

  function observe(el) {
    if (!el) return;
    new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
  }

  function init() {
    observe(document.getElementById('main-cart-footer'));
    observe(document.querySelector('cart-drawer'));
    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
